import { render } from "./PositionContent.vue?vue&type=template&id=bb9c0786"
import script from "./PositionContent.vue?vue&type=script&lang=js"
export * from "./PositionContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__